module.exports = __webpack_public_path__ + "img/features-bg_4.123aa7fe.png";